import * as THREE from 'three';

export default class XY3DSurface3_geom  extends THREE.BufferGeometry{
   /*
    Creates a surface in the x-y plane with defined z height points.
    Parameters:
        points: Array of arrays of any object that has x,y,z properties
        frontside: true if surfaces is on the front side, false for back side


   */
    private _Nx:number;
    private _Ny:number;
    private _vertices:Array<number>;
    private _faces:Array<number>;

    
    constructor(points:Array<Array<any>>, frontside:boolean = true){
        super();
        //console.log("In XY3DSurface3_geom constructor...")

        /*

        */

        this._Nx = points.length;
        this._Ny = points[0].length;

        let ix:number;
        let iy:number;
        let vx:number;
        let vy:number;
        let vz:number;
        let kVa:number;
        let kVb:number;
        let kVc:number;
        let kVd:number;
        // Top side:
        //console.log("Make vertices...");
        let k:number = 0;
        this._vertices = [];
        for (iy=0; iy< this._Ny; iy++){
            for (ix=0; ix< this._Nx; ix++){
                vx = points[ix][iy].x;
                vy = points[ix][iy].y;
                vz = points[ix][iy].z;
                if (isNaN(vx)||isNaN(vy)||isNaN(vz)){
                    debugger
                }
                this._vertices.push(vx, vy, vz); // Push a triplet of x/y/z numbers onto the _vertices list
                //this.vertices[k] = new THREE.Vector3(vx, vy, vz);
                //console.log("j = "+j+", i = "+i+", k = "+k+", vx = "+vx.toFixed(2)+", vy = "+vx.toFixed(2)+", vz = "+vx.toFixed(2));
                k++;
            }
        }
        this.setAttribute('position', new THREE.Float32BufferAttribute(this._vertices, 3));

        this._faces = [];
        //let nVertices = k;
        //console.log("Make faces...");
        for (iy=0; iy<= this._Ny-2; iy++){
            for (ix=0; ix< this._Nx-1; ix++){
                kVa = iy*this._Nx + ix;
                kVb = iy*this._Nx + ix + 1;
                kVd = (iy+1)*this._Nx + ix;
                kVc = (iy+1)*this._Nx + ix + 1;
                //console.log("j = "+j+", i = "+i+", kVa = "+kVa+", kVb = "+kVb+", kVc = "+kVc+", kVd = "+kVd);
                if (frontside){
                    this._faces.push(kVa, kVb, kVc);
                    this._faces.push(kVc, kVd, kVa);
                    //this.faces.push( new THREE.Face3(kVa, kVb, kVc));
                    //this.faces.push( new THREE.Face3(kVc, kVd, kVa));
                } else {
                    this._faces.push(kVa, kVc, kVb);
                    this._faces.push(kVc, kVa, kVd);                
                    //this.faces.push( new THREE.Face3(kVa, kVc, kVb));
                    //this.faces.push( new THREE.Face3(kVc, kVa, kVd));                     
                }
            }
        }
        this.setIndex(new THREE.Uint32BufferAttribute(this._faces, 1));


        this.computeVertexNormals();
    } // End of constructor
   

 } // End of class
